module.exports = __webpack_public_path__ + "static/media/sense4067.b596f218.jpg";